<template>
    <div @click="loginValidate()" class="card">
        <v-img :item="item" :img="item.img" :key="item.img.url" :is-video="isVideo"/>
        <h5 class="title" v-html="item.title"></h5>
        <!-- <p v-if="item.subtitle" class="q-ma-none" v-html="item.subtitle"></p>-->
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'

    export default {
        name: 'VCard',

        props: {
            layout: {
                type: String,
                required: true
            },
            item: {
                type: Object,
                required: true
            },
            isVideo: Boolean
        },
        computed: {
            ...mapGetters({
                user: 'auth/user',
            })

        },
        methods: {
            loginValidate() {
                if (this.user) {
                    if (this.user.subscription_status == 150)
                        this.$login(this.item.uri.replace('/desporto/','*desporto*'));
                    else
                        this.$router.push(this.item.uri)
                }
                else
                    this.$login(this.item.uri.replace('/desporto/','*desporto*'));

            }

        }

    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/front/Card.vue